import React, {
  useEffect,
  useState,
  useMemo,
  useRef,
  useCallback,
} from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import Footer from "../../Components/UI/Footer/Footer";
import Header from "../../Components/UI/Header/Header";
import SpinnerHandler from "../../hoc/SpinnerHandler/SpinnerHandler";
import averageVolumeImg from "../../assets/Charts/average-volume.png";
import { Line } from "react-chartjs-2";
import moment from "moment-jalaali";
import Select from "./Select/Select";
import CInput from "../../Components/UI/CInput/CInput";
import Icon from "@mdi/react";
import { mdiCloudUploadOutline, mdiPageFirst, mdiPageLast } from "@mdi/js";
import useAsync from "../../hooks/asyncRequests";

const thisPageData = {
  title: "آبخوان",
  options: [
    {
      value: "میانگین تغییر حجم",
      gainValue: "volume_change_mean",
      unit: "m/s",
      img: averageVolumeImg,
      color: "50, 3, 227",
    },
  ],
  download: "aquifer_detail",
  downloadId: "aquifer_id",
};

const lbDic = {
  volume_change_mean: "میانگین تغییر حجم",
};

const AquiferChart = () => {
  const location = useLocation();
  const token = useSelector((state) => state.auth.Token);
  const [isLoading, setIsLoading] = useState(false);
  const [Last, setLast] = useState();
  const [value, setValue] = useState(thisPageData.options[0].gainValue);
  const [Color, setColor] = useState("#9fa8da");
  const [Range, setRange] = useState(1);
  const [Start, setStart] = useState(moment());
  const [End, setEnd] = useState(moment());
  const chartRef = useRef(null);
  const [AllChartData, setAllChartData] = useState({});
  const [chartData, setChartData] = useState({});
  const { isLoadingAsync, finalData, clearAsync, NewRequest, Key } = useAsync({
    Key: 1,
    reqData: {
      chart: {
        url: `chart/aquifer-volume/?range=${Range}&aquifer_id=${location.state.id}`,
        method: "GET",
        header: { Authorization: `Bearer ${token}` },
      },
    },
  });
  useEffect(() => {
    console.log(finalData);
    if (!finalData || !Key || Key === "loading") {
      return;
    }

    if (AllChartData[Key]) {
      return;
    }

    const { chart } = finalData;

    if (chart && !chart.error) {
      const allChartData = { labels: [] };
      const allOptions = thisPageData.options;

      allOptions.map((e) => {
        allChartData[e.gainValue] = [];
        return 0;
      });

      let date;
      chart?.data?.forEach((CD) => {
        date = moment(CD.date).format("jYYYY-jMM-jDD");
        allChartData.labels.push(date);
        allOptions.forEach((e) => {
          allChartData[e.gainValue].push({ y: CD[e.gainValue], x: date });
        });
      });

      const reversed = {};

      for (const key in allChartData) {
        reversed[key] = allChartData[key].reverse();
      }

      console.log(reversed);
      setAllChartData((pre) => {
        const p = { ...pre };
        p[Key] = reversed;
        return p;
      });

      setLast(chart.latest);

      setChartData({
        data: {
          datasets: [
            {
              pointHoverRadius: 5,
              pointHitRadius: 30,
              tension: 0.4,
              fill: false,
              cubicInterpolationMode: "monotone",
              parsing: false,
            },
          ],
        },
        options: {
          animation: false,
          normalized: true,
          spanGaps: true,
          // showLine: false,
          datasets: {
            line: {
              pointRadius: 0, // disable for all `'line'` datasets
            },
          },
          plugins: {
            legend: {
              display: false,
            },
          },
          scales: {
            yAxes: {
              title: {
                display: true,
                text: "yAxisTitle",
                font: {
                  size: 15,
                },
              },
            },
            xAxes: {
              x: {
                type: "time",
                time: {
                  unit: "month",
                },
              },
              title: {
                display: true,
                text: "زمان",
                font: {
                  size: 15,
                  family: "IRANSansWeb",
                  weight: "bold",
                },
              },
              ticks: {
                maxTicksLimit: 12,
              },
            },
          },
        },
      });
    }

    clearAsync();
  }, [finalData, setAllChartData, setChartData, clearAsync, AllChartData, Key]);
  useEffect(() => {
    const colors = {};
    thisPageData.options.forEach((element) => {
      colors[element.gainValue] = element.color;
    });
    setColor(colors);

    console.log(colors);
  }, [setColor]);
  useEffect(() => {
    if (value && AllChartData[Range]) {
      setChartData(
        (pre) =>
          pre &&
          Object.keys(pre).length && {
            ...pre,
            data: {
              labels: AllChartData[Range].labels,
              datasets: [
                {
                  ...pre.data.datasets[0],
                  label: value,
                  data: AllChartData[Range][value],
                  // backgroundColor: `rgba(${Color[value]}, 0.4)`,
                  backgroundColor: `rgb(${Color[value]})`,
                  borderColor: `rgb(${Color[value]})`,
                },
              ],
            },
            options: {
              ...pre.options,
              scales: {
                ...pre.options.scales,
                yAxes: {
                  title: {
                    ...pre.options.scales.yAxes.title,
                    text: lbDic[value],
                    font: {
                      size: 15,
                      family: "IRANSansWeb",
                      weight: "bold",
                    },
                  },
                },
              },
            },
          }
      );
    }
  }, [value, setChartData, AllChartData, Color, Range]);
  useEffect(() => {
    if (!AllChartData[Range] && Range !== 1) {
      NewRequest({
        NewKey: Range,
        NewReqData: {
          chart: {
            url: `chart/aquifer-volume/?range=${Range}&aquifer_id=${location.state.id}`,
            method: "GET",
            header: { Authorization: `Bearer ${token}` },
          },
        },
      });
    }
  }, [NewRequest, Range, AllChartData, location, token]);

  const downloadCSV = useCallback(() => {
    if (Start.format("YYYY-MM-DD") === End.format("YYYY-MM-DD")) {
      return;
    }
    setIsLoading(true);

    fetch(
      `http://213.233.177.17:8022/download/${thisPageData.download}?${
        thisPageData.downloadId
      }=${location.state.id}&start_date=${Start.format(
        "YYYY-MM-DD"
      )}&end_date=${End.format("YYYY-MM-DD")}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => {
        response.headers.forEach((value, name) => {
          console.log(name + ": " + value);
        });

        return response.blob().then((data) => {
          const the = response.headers.get("Content-disposition");
          const thea = the.slice(the.indexOf('"') + 1, the.length - 1);
          console.log(the);
          console.log(thea);

          return {
            blob: data,
            fileName: thea,
          };
        });
      })
      .then(({ blob, fileName }) => {
        console.log(fileName);

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove(); //afterwards we remove the element again)
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  }, [token, location, Start, End, setIsLoading]);

  const chart = useMemo(() => {
    if (chartData) {
      let dt = null;
      if (chartData.data && chartData.data.datasets[0].data) {
        dt = chartData;
      }

      return dt && <Line ref={chartRef} {...dt} />;
    }
  }, [chartData, chartRef]);
  const navigation = useMemo(() => {
    return (
      <div className="center">
        <span onClick={() => setRange((pre) => pre + 1)}>
          <Icon
            path={mdiPageLast}
            title="NEXT"
            size={1}
            style={{ visibility: !Range ? "hidden" : "visible" }}
          />
        </span>
        <span>{Range}</span>
        <span onClick={() => setRange((pre) => (pre === 1 ? 1 : pre - 1))}>
          <Icon
            path={mdiPageFirst}
            title="PREVIOUS"
            size={1}
            style={{ visibility: Range === 1 ? "hidden" : "visible" }}
          />
        </span>
      </div>
    );
  }, [Range, setRange]);
  const downloadUI = useMemo(() => {
    if (location.state.id && thisPageData.download) {
      return (
        <div className="chartDownload">
          <CInput
            config={{
              type: "calendar",
              placeholder: "تاریخ شروع",
            }}
            value={Start}
            direction="rtl"
            changed={setStart}
          />
          <CInput
            config={{
              type: "calendar",
              placeholder: "تاریخ پایان",
            }}
            value={End}
            direction="rtl"
            changed={setEnd}
          />
          <button onClick={downloadCSV}>
            دریافت داده ها به فرمت CSV{" "}
            <Icon path={mdiCloudUploadOutline} size={1} />
          </button>
        </div>
      );
    } else return null;
  }, [downloadCSV, Start, End, setStart, setEnd, location]);

  return (
    <SpinnerHandler isLoading={isLoadingAsync || isLoading}>
      <Header />
      <div className="chartInfo">
        <h2>
          {thisPageData.title} {location.state.name}
        </h2>
        {!isLoadingAsync && (
          <Select
            value={value}
            setValue={setValue}
            list={thisPageData.options}
            Color={Color[value]}
            last={Last}
          />
        )}
      </div>
      <div className="center damChart">
        {navigation}
        <div>{chart}</div>
      </div>
      {downloadUI}
      <Footer />
    </SpinnerHandler>
  );
};

export default AquiferChart;
